<template>
  <section>
    <div class="card">
      <div class="card-header">
        <h4>Logout</h4>
      </div>
      <div class="card-body">
        zu exportierender Monat:
        <br />
        <el-date-picker
          v-model="month"
          type="month"
          placeholder="Monat auswählen"
          value-format="yyyy-MM-dd"
          format="MM.yyyy"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
        <hr />
        <div>
          Belege exportieren als:
          <div class="custom-control custom-radio">
            <input
              class="form-check-input custom-control-input"
              type="radio"
              value="mail"
              v-model="action"
              id="Email"
            />
            <label class="form-check-label custom-control-label" for="Email"
              >E-Mail</label
            >
          </div>
          <div class="custom-control custom-radio">
            <input
              class="form-check-input custom-control-input"
              type="radio"
              value="download"
              v-model="action"
              id="download"
            />
            <label class="form-check-label custom-control-label" for="download"
              >Download</label
            >
          </div>
        </div>
        <div v-if="action == 'mail'">
          <hr />
          E-Mail senden an:
          <select v-model="email" class="form-control">
            <option selected value="new">neue E-Mail-Adresse</option>
            <option v-for="(email, key) in emails" :key="key" :value="email">{{
              email
            }}</option>
          </select>
          <br />
          <input
            v-if="email == 'new'"
            v-model="newEmail"
            class="form-control"
            type="text"
            placeholder="E-Mail-Adresse"
          />
        </div>
        <div>
          <button @click="presist()" class="btn btn-default">
            Belege exportieren
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="babel">
import { DatePicker } from 'element-ui';

export default {
    components: {
      [DatePicker.name]: DatePicker,
    },
    data() {
      return {
        pickerOptions: {},
        month: '',
        action: 'mail',
        email: Laravel.user.email,
        newEmail: '',
        emails: {}
      };
    },
    methods: {
      presist() {
      this.$http
        .post("/api/v1/exportInvoice/export", {
          month: this.month,
          action: this.action,
          email: this.email,
          newEmail: this.newEmail
        })
        .then(() => {
          this.$notify({
            title: "Belege werden exportiert",
            type: "success"
          });
        })
        .catch(error => {
          if (
            error.response &&
            error.response.data
          ) {
            let errors = [];
            for (const value of Object.entries(error.response.data.errors)) {
              value[1].forEach(function(element) {
                errors.push(element);
              });
            }
            this.$notify({
              title: error.response.data.message,
              text: errors.join("<br>"),
              type: "error"
            });
          }
        });
      }
    },
    created() {
      this.$http
        .get("/api/v1/exportInvoice/firstDate")
        .then(({ data }) => {
          this.pickerOptions = {
            disabledDate(time) {
              return time.getTime() > Date.now() || time.getTime() < Date.parse(data);
            },
          }
        });

      this.$http
        .get("/api/v1/exportInvoice/emails")
        .then(({ data }) => {
          this.emails = data;
        });
    }
};
</script>
